import { useErrorSnackbar } from 'shared/hooks/useErrorSnackbar';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { useBypassNavigationPrompt } from 'shared/routing/NavigationBlock';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { useSuperPaySettings } from '../../../profile/data/SuperPayAPI';
import { useVerificationAvailable } from '../../../profile/superpay/account-details/useVerificationAvailable';
import { SUPERPAY_WEBVIEW_ROUTES } from '../../../profile/superpay/SuperPayRoute';
import { BankAccountVerificationWebViewStep } from './BankAccountVerificationWebViewStep';
import { SuperPayWebviewHeader } from './SuperPayWebviewHeader';

export function VerifyBankAccountWebViewPage() {
  const navigate = useBypassNavigationPrompt();
  const { refetch: refetchCarrierSettings } = useCarrierSettings();
  const {
    data: superPaySettings,
    error,
    refetch: refetchSuperPaySettings,
  } = useSuperPaySettings();
  useErrorSnackbar(error);

  useVerificationAvailable(SUPERPAY_WEBVIEW_ROUTES.accountDetails, {
    skip: !!superPaySettings?.bank_accounts?.[0],
  });

  useDocumentTitle('SuperPay');

  return (
    <SuperPayWebviewHeader>
      <BankAccountVerificationWebViewStep
        bankAccount={superPaySettings?.bank_accounts?.[0]}
        onComplete={() => {
          void refetchCarrierSettings();
          void refetchSuperPaySettings();
          navigate(
            `${SUPERPAY_WEBVIEW_ROUTES.accountDetails}?utm_medium=Verify Bank Account Drawer`,
            { replace: true },
          );
        }}
      />
    </SuperPayWebviewHeader>
  );
}
